import React from 'react';
import './DarkCard.scss';

const NormalCard = ({title, subtitle, subtitleicon, stats, icon, trend, statsicon}) => {

  return (
    <React.Fragment>
      <div className={`${trend == "down" ? "bg-[#35c759]" : trend === "up" ? "bg-[#ff373c]" : "border"} flex w-full flex-1 px-2 py-2 min-h-24 justify-start items-center rounded-md  dark-bg`}>
        <span className='flex justify-start items-start'>
          {/* <div className={`${trend == "down" ? "bg-green-200" : trend == "up" ? "bg-red-200" : ""} me-2 w-10 h-10 flex justify-center items-center rounded-full   text-2xl flex-shrink-0`}>
            {icon && icon}
          </div> */}
          <span>
            <div className={`${trend == "down" ? "text-up-trend" : trend === "up" ? "text-down-trend" : "state-card-text"} mb-1 text-[1.5rem] leading-[1.2] font-bold`}>
              {statsicon && statsicon} {stats && stats}
            </div>
            <p className={`text-sm font-bold mb-2 ${trend == "up" || trend === "down" ?  " text-white" : "state-card-text"}`}>{title && title}</p>
            <p className={`mb-0 text-xs ${trend == "up" || trend === "down" ?  " text-white" : "state-card-text"}`}>{subtitleicon && subtitleicon}{subtitle && subtitle}</p>
          </span>
        </span>
      </div>
    </React.Fragment>
  );
}

export default NormalCard;
